import { Phone, ArrowRight, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BUSINESS, HERO_VIDEO, HERO_VIDEO_POSTER } from "@/lib/siteData";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <video
          data-testid="hero-video"
          className="w-full h-full object-cover"
          src={HERO_VIDEO}
          poster={HERO_VIDEO_POSTER}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          aria-hidden="true"
        />
        <div className="absolute inset-0 hero-gradient" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32 w-full">
        <div className="max-w-3xl text-white fade-up">
          <div
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-sm mb-6"
            data-testid="hero-location-pill"
          >
            <MapPin className="w-4 h-4 text-green-300" />
            <span>
              Serving {BUSINESS.areas.slice(0, 3).join(", ")} &amp; surrounding areas
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Bringing Life Back To Your{" "}
            <span className="text-green-300">Outdoor Spaces</span>.
          </h1>

          <p
            data-testid="hero-subheadline"
            className="mt-6 text-lg sm:text-xl text-white/85 max-w-2xl leading-relaxed"
          >
            Professional pond and garden maintenance services across East Grinstead
            and surrounding areas.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a href="#contact" data-testid="hero-quote-cta-link">
              <Button
                data-testid="hero-quote-cta"
                size="lg"
                className="bg-green-600 hover:bg-green-700 text-white rounded-full px-8 py-6 text-base font-semibold shadow-xl shadow-green-900/40 group"
              >
                Get in Touch
                <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-1" />
              </Button>
            </a>
            <a href={`tel:${BUSINESS.phoneTel}`} data-testid="hero-call-cta-link">
              <Button
                data-testid="hero-call-cta"
                size="lg"
                variant="outline"
                className="border-2 border-white/70 bg-white/10 hover:bg-white text-white hover:text-green-800 backdrop-blur-md rounded-full px-8 py-6 text-base font-semibold"
              >
                <Phone className="w-5 h-5 mr-2" />
                Call Now: {BUSINESS.phone}
              </Button>
            </a>
          </div>

          <p className="mt-8 text-sm text-white/70" data-testid="hero-tagline">
            Reliable, friendly &amp; professional pond and garden care — all year round.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
